<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-tabs v-model="tabValue" slider-color="primary">
        <v-tab>Map Factor</v-tab>
        <v-tab v-show="glSys == 2">Source of GLAC</v-tab>
        <v-tab v-if="false">Statistic Type GLAC</v-tab>
        <v-tab-item key="mapFactor">
          <div key="mapFactor">
            <v-card-title>
              <div class="headline" v-if="newMapping">New Map Factor</div>
              <div class="headline" v-else>Manage Map Factor</div>
            </v-card-title>
            <v-card-text>
              <v-flex xs12 class="mt-3">
                <message :messages="messages"></message>
              </v-flex>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs6 v-if="newMapping">
                    <v-autocomplete
                      :label="labels.glapplnInt"
                      :items="glapplnIntList"
                      item-text="label"
                      item-value="value"
                      v-model="mapFactorForm.glapplnInt"
                      data-vv-name="glapplnInt"
                      :data-vv-as="labels.glapplnInt"
                      :error-messages="errors.collect('glapplnInt')"
                      v-validate="'required'"
                      @change="checkGlApplnInt(mapFactorForm.glapplnInt)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs6 v-else>
                    <v-subheader class="queryLabel">{{ labels.glapplnInt }}</v-subheader>
                    <div class="queryValue">{{ mapFactorForm.glapplnInt | glapplnIntDesc }}</div>
                  </v-flex>
                </v-layout>
                <v-container v-if="this.mapFactorForm.glApplnIntTtyAcct === false">
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctCtyRisk" v-model="mapFactorForm.sepAcctCtyRisk"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctBrn" v-model="mapFactorForm.sepAcctBrn"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctDRI" v-model="mapFactorForm.sepAcctDri"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctPolType" v-model="mapFactorForm.sepAcctPolType"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctBusCls" v-model="mapFactorForm.sepAcctBusCls"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctDept" v-model="mapFactorForm.sepAcctDept"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctCtyCed" v-model="mapFactorForm.sepAcctCtyCed"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctCtyRi" v-model="mapFactorForm.sepAcctCtyRi"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-container v-else>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctStmtLvl" v-model="mapFactorForm.sepAcctStmtLvl"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctStmtLnGL" v-model="mapFactorForm.sepAcctStmtLnGL"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctBAGL" v-model="mapFactorForm.sepAcctBAGL"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctCedAreaGL" v-model="mapFactorForm.sepAcctCedAreaGL"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctRIAreaGL" v-model="mapFactorForm.sepAcctRIAreaGL"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctRiskAreaGL" v-model="mapFactorForm.sepAcctRiskAreaGL"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox :label="labels.sepAcctCesCat" v-model="mapFactorForm.sepAcctCesCat"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-layout row-wrap>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                    <div class="queryValue">{{ mapFactorForm.createdBy }}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                    <div class="queryValue">{{ mapFactorForm.createdDate | formatDate }}</div>
                  </v-flex>
                </v-layout>
                <v-layout row-wrap v-if="!newMapping">
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                    <div class="queryValue">{{ mapFactorForm.modifiedBy }}</div>
                  </v-flex>
                  <v-flex xs6>
                    <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                    <div class="queryValue">{{ mapFactorForm.modifiedDate | formatDate }}</div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </div>
        </v-tab-item>
        <v-tab-item v-if="glSys == 2" key="srcGlac" >
          <div key="srcGlac">
            <v-card-title>
              <div class="headline">Source GL Analysis Code</div>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <template v-for="(value, key) in template1">
                    <v-flex xs6 :key="key">
                      <v-autocomplete
                        :label="template1[key]"
                        :items="mapGlacList"
                        item-text="label"
                        item-value="value"
                        v-model="mapFactorForm[key]"
                        @change="checkMapGlac(key)"
                      ></v-autocomplete>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-card-text>
          </div>
        </v-tab-item>
        <v-tab-item key="sunGL" >
          <div key="sunGL">
            <v-card-title>
              <div class="headline">Statistic Type GL Analysis Code</div>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <template v-for="(value, key) in template2">
                    <v-flex xs6 :key="key">
                      <v-text-field
                        :label="template2[key]"
                        v-model="mapFactorForm[key]"
                        :disabled="template2AE[key]"
                        append-icon="mdi-magnify"
                      ></v-text-field>
                    </v-flex>
                  </template>
                </v-layout>
              </v-container>
            </v-card-text>
          </div>
        </v-tab-item>
      </v-tabs>
      <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
        <span>Cancel</span>
        <v-icon right dark>mdi-cancel</v-icon>
      </v-btn>
      <v-btn color="primary" dark class=" mr-2" @click="doSave" :loading="submitting">
        Save GL Mapping
        <v-icon right>mdi-content-save</v-icon>
      </v-btn>
    </v-card>
  </lazy-div>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { glAppInterface, mapGLAC } from '@/const/acct/glAcct'
export default {
  data() {
    return {
      labels: {
        glapplnInt: 'GL Application Interface',
        sepAcctCtyRisk: 'Country of Risk',
        sepAcctDRI: 'Direct / RI Inwards',
        sepAcctBrn: 'Branch',
        sepAcctPolType: 'Policy Type',
        sepAcctBusCls: 'Business Class',
        sepAcctNoSfx: 'Suffix',
        sepAcctDept: 'Department',
        sepAcctCtyCed: 'Country of Cedant',
        sepAcctCtyRi: 'Country of Reinsurance',
        sepAcctResCat: 'Claim Payment Catagory',
        sepAcctStmtLvl: 'Statement Level',
        sepAcctStmtLnGL: 'Statement Line GL',
        sepAcctBAGL: 'Business Analysis GL',
        sepAcctCedAreaGL: 'Cedant Area GL',
        sepAcctRIAreaGL: 'RI Area GL',
        sepAcctRiskAreaGL: 'Risk Area GL',
        sepAcctCesCat: 'Cession Category',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      mapFactorForm: {
        glApplnIntTtyAcct: false, // if glApplnInt = 7000 - 7999 then true
        glapplnInt: null,
        sepAcctCtyRisk: false,
        sepAcctDri: false,
        sepAcctBrn: false,
        sepAcctPolType: false,
        sepAcctBusCls: false,
        sepAcctNoSfx: false,
        sepAcctDept: false,
        sepAcctCtyCed: false,
        sepAcctCtyRi: false,
        sepAcctResCat: false,
        srcGlac1: null,
        srcGlac2: null,
        srcGlac3: null,
        srcGlac4: null,
        srcGlac5: null,
        srcGlac6: null,
        srcGlac7: null,
        srcGlac8: null,
        srcGlac9: null,
        srcGlac10: null,
        statsTypeGlac1: null,
        statsTypeGlac2: null,
        statsTypeGlac3: null,
        statsTypeGlac4: null,
        statsTypeGlac5: null,
        statsTypeGlac6: null,
        statsTypeGlac7: null,
        statsTypeGlac8: null,
        statsTypeGlac9: null,
        statsTypeGlac10: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null,
        sepAcctStmtLvl: false,
        sepAcctStmtLnGL: false,
        sepAcctBAGL: false,
        sepAcctCedAreaGL: false,
        sepAcctRIAreaGL: false,
        sepAcctCesCat: false,
        sepAcctRiskAreaGL: false
      },
      template1: {
        srcGlac1: 'Source GLAC 1',
        srcGlac2: 'Source GLAC 2',
        srcGlac3: 'Source GLAC 3',
        srcGlac4: 'Source GLAC 4',
        srcGlac5: 'Source GLAC 5',
        srcGlac6: 'Source GLAC 6',
        srcGlac7: 'Source GLAC 7',
        srcGlac8: 'Source GLAC 8',
        srcGlac9: 'Source GLAC 9',
        srcGlac10: 'Source GLAC 10'
      },
      template2: {
        statsTypeGlac1: 'Statistic Type GLAC 1',
        statsTypeGlac2: 'Statistic Type GLAC 2',
        statsTypeGlac3: 'Statistic Type GLAC 3',
        statsTypeGlac4: 'Statistic Type GLAC 4',
        statsTypeGlac5: 'Statistic Type GLAC 5',
        statsTypeGlac6: 'Statistic Type GLAC 6',
        statsTypeGlac7: 'Statistic Type GLAC 7',
        statsTypeGlac8: 'Statistic Type GLAC 8',
        statsTypeGlac9: 'Statistic Type GLAC 9',
        statsTypeGlac10: 'Statistic Type GLAC 10'
      },
      template2AE: {
        statsTypeGlac1: false,
        statsTypeGlac2: false,
        statsTypeGlac3: false,
        statsTypeGlac4: false,
        statsTypeGlac5: false,
        statsTypeGlac6: false,
        statsTypeGlac7: false,
        statsTypeGlac8: false,
        statsTypeGlac9: false,
        statsTypeGlac10: false
      },
      glSys: 1,
      tabValue: 0,
      submitting: false
    }
  },
  created() {
    // this.doInit()
  },
  methods: {
    async doCheckGlSys() {
      const apiURI = this.menu.miscAcctParam
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result.data
          this.glSys = data.miscAcctParam.glSys
        } catch (err) {
          this.glSys = 1
        }
      }
    },
    async doInit() {
      await this.doCheckGlSys()
      if (!this.newMapping) {
        const apiURI = this.menu.glMapping
        if (apiURI) {
          this.checkGlApplnInt(this.glapplnInt)
          try {
            const expand = {
              glapplnInt: this.glapplnInt
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.mapFactorForm.glapplnInt = data.GLMapping.glapplnInt
              this.mapFactorForm.sepAcctCtyRisk = data.GLMapping.sepAcctCtyRisk
              this.mapFactorForm.sepAcctDri = data.GLMapping.sepAcctDri
              this.mapFactorForm.sepAcctBrn = data.GLMapping.sepAcctBrn
              this.mapFactorForm.sepAcctPolType = data.GLMapping.sepAcctPolType
              this.mapFactorForm.sepAcctBusCls = data.GLMapping.sepAcctBusCls
              this.mapFactorForm.sepAcctNoSfx = data.GLMapping.sepAcctNoSfx
              this.mapFactorForm.sepAcctDept = data.GLMapping.sepAcctDept
              this.mapFactorForm.sepAcctCtyCed = data.GLMapping.sepAcctCtyCed
              this.mapFactorForm.sepAcctCtyRi = data.GLMapping.sepAcctCtyRi
              this.mapFactorForm.sepAcctResCat = data.GLMapping.sepAcctResCat
              this.mapFactorForm.srcGlac1 = data.GLMapping.srcGlac1
              this.mapFactorForm.srcGlac2 = data.GLMapping.srcGlac2
              this.mapFactorForm.srcGlac3 = data.GLMapping.srcGlac3
              this.mapFactorForm.srcGlac4 = data.GLMapping.srcGlac4
              this.mapFactorForm.srcGlac5 = data.GLMapping.srcGlac5
              this.mapFactorForm.srcGlac6 = data.GLMapping.srcGlac6
              this.mapFactorForm.srcGlac7 = data.GLMapping.srcGlac7
              this.mapFactorForm.srcGlac8 = data.GLMapping.srcGlac8
              this.mapFactorForm.srcGlac9 = data.GLMapping.srcGlac9
              this.mapFactorForm.srcGlac10 = data.GLMapping.srcGlac10
              this.mapFactorForm.statsTypeGlac1 = data.GLMapping.statsTypeGlac1
              this.mapFactorForm.statsTypeGlac2 = data.GLMapping.statsTypeGlac2
              this.mapFactorForm.statsTypeGlac3 = data.GLMapping.statsTypeGlac3
              this.mapFactorForm.statsTypeGlac4 = data.GLMapping.statsTypeGlac4
              this.mapFactorForm.statsTypeGlac5 = data.GLMapping.statsTypeGlac5
              this.mapFactorForm.statsTypeGlac6 = data.GLMapping.statsTypeGlac6
              this.mapFactorForm.statsTypeGlac7 = data.GLMapping.statsTypeGlac7
              this.mapFactorForm.statsTypeGlac8 = data.GLMapping.statsTypeGlac8
              this.mapFactorForm.statsTypeGlac9 = data.GLMapping.statsTypeGlac9
              this.mapFactorForm.statsTypeGlac10 = data.GLMapping.statsTypeGlac10
              this.mapFactorForm.createdBy = data.createdBy
              this.mapFactorForm.createdDate = data.createdDate
              this.mapFactorForm.modifiedBy = data.modifiedBy
              this.mapFactorForm.modifiedDate = data.modifiedDate
              this.mapFactorForm.sepAcctStmtLvl = data.GLMapping.sepAcctStmtLvl
              this.mapFactorForm.sepAcctStmtLnGL = data.GLMapping.sepAcctStmtLnGL
              this.mapFactorForm.sepAcctBAGL = data.GLMapping.sepAcctBAGL
              this.mapFactorForm.sepAcctCedAreaGL = data.GLMapping.sepAcctCedAreaGL
              this.mapFactorForm.sepAcctRIAreaGL = data.GLMapping.sepAcctRIAreaGL
              this.mapFactorForm.sepAcctCesCat = data.GLMapping.sepAcctCesCat
              this.mapFactorForm.sepAcctRiskAreaGL = data.GLMapping.sepAcctRiskAreaGL
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.mapFactorForm.sepAcctCtyRisk = false
        this.mapFactorForm.sepAcctDri = false
        this.mapFactorForm.sepAcctBrn = false
        this.mapFactorForm.sepAcctPolType = false
        this.mapFactorForm.sepAcctBusCls = false
        this.mapFactorForm.sepAcctNoSfx = false
        this.mapFactorForm.sepAcctDept = false
        this.mapFactorForm.sepAcctCtyCed = false
        this.mapFactorForm.sepAcctCtyRi = false
        this.mapFactorForm.sepAcctResCat = false
        this.mapFactorForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.mapFactorForm.createdDate = new Date()
        this.mapFactorForm.sepAcctStmtLvl = false
        this.mapFactorForm.sepAcctStmtLnGL = false
        this.mapFactorForm.sepAcctBAGL = false
        this.mapFactorForm.sepAcctCedAreaGL = false
        this.mapFactorForm.sepAcctRIAreaGL = false
        this.mapFactorForm.sepAcctCesCat = false
        this.mapFactorForm.sepAcctRiskAreaGL = false
        for (let i = 0; i < 10; i++) {
          this.mapFactorForm['srcGlac' + (i + 1)] = 0
        }
      }
      this.$store.commit('GLMAPPING_COMMIT_KEY', this.mapFactorForm)
      this.doTemplate2AE()
    },
    doTemplate2AE() {
      for (let k in this.template2AE) {
        let index = k.substring(13)
        if (this.mapFactorForm['srcGlac' + index] >= 40) {
          this.template2AE[k] = false
        } else {
          this.template2AE[k] = true
        }
      }
    },
    checkMapGlac(key) {
      const index = key.substring(7)
      const newKey = 'statsTypeGlac' + index
      if (this.mapFactorForm[key] >= 40) {
        this.template2AE[newKey] = false
      } else {
        this.template2AE[newKey] = true
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitting = true
          if (this.newMapping) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
          this.$store.commit('GLMAPPING_COMMIT_KEY', this.mapFactorForm)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createGlMapping
      if (apiURI) {
        this.$http
          .post(apiURI, this.mapFactorForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.$router.push({
                name: 'mapFactor',
                params: {
                  glapplnInt: this.mapFactorForm.glapplnInt
                }
              })
            }
            this.submitting = false
          })
          .catch((err) => {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateGlMapping
      if (apiURI) {
        this.$http
          .put(apiURI, this.mapFactorForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.notify(data)
              this.doInit()
            }
            this.submitting = false
          })
          .catch((err) => {
            this.submitting = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doCancel() {
      this.$router.push({ name: 'glMapping' })
    },
    checkGlApplnInt(data) {
      if (data >= 7000 && data <= 7999) {
        this.mapFactorForm.sepAcctCtyRisk = false
        this.mapFactorForm.sepAcctDri = false
        this.mapFactorForm.sepAcctBrn = false
        this.mapFactorForm.sepAcctPolType = false
        this.mapFactorForm.sepAcctBusCls = false
        this.mapFactorForm.sepAcctNoSfx = false
        this.mapFactorForm.sepAcctDept = false
        this.mapFactorForm.sepAcctCtyCed = false
        this.mapFactorForm.sepAcctCtyRi = false
        this.mapFactorForm.sepAcctResCat = false
        this.mapFactorForm.glApplnIntTtyAcct = true
      } else {
        this.mapFactorForm.sepAcctStmtLvl = false
        this.mapFactorForm.sepAcctStmtLnGL = false
        this.mapFactorForm.sepAcctBAGL = false
        this.mapFactorForm.sepAcctCedAreaGL = false
        this.mapFactorForm.sepAcctRIAreaGL = false
        this.mapFactorForm.sepAcctCesCat = false
        this.mapFactorForm.sepAcctRiskAreaGL = false
        this.mapFactorForm.glApplnIntTtyAcct = false
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    newMapping() {
      return this.glapplnInt === 'new'
    },
    mapGlacList() {
      let result = []
      Object.keys(mapGLAC).forEach((key) => {
        const status = mapGLAC[key]
        result.push({
          label: status,
          value: Number(key)
        })
      })
      return result
    },
    glapplnIntList() {
      let result = []
      Object.keys(glAppInterface).forEach((key) => {
        const status = glAppInterface[key]
        result.push({
          label: status,
          value: Number(key)
        })
      })
      return result
    }
  },
  watch: {
    glapplnInt(value) {
      this.doInit()
    }
  },
  filters: {
    glapplnIntDesc(value) {
      return value + ' - ' + glAppInterface[value]
    },
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  mixins: [MessageMixin],
  props: ['glapplnInt']
}
</script>

<style>
</style>
